"use client";

import Image from "next/image";
import Marquee from "@/components/shared/carousel/Marquee";

interface CustomerLogosProps {
  title?: string;
  logos: {
    src: string;
    alt: string;
  }[];
}

export default function CustomerLogosCarousel({ logos }: CustomerLogosProps) {
  const validLogos = logos.filter((logo) => logo.src);
  if (validLogos.length === 0) return null;

  // An even number of copies keeps the -50% marquee loop seamless; at least
  // 16 items per half so the strip fills wide viewports without a gap.
  const copies = 2 * Math.ceil(16 / validLogos.length);
  const extendedLogos = Array.from({ length: copies }, () => validLogos).flat();

  return (
    <div className="relative mt-10">
      {/* Fade effect containers */}
      <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-[100px] bg-linear-to-r from-[#101010]  via-[#101010]/50 to-transparent" />
      <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-[100px] bg-gradient-to-l from-[#101010]  via-[#101010]/50 to-transparent" />

      <Marquee speed={42} className="pointer-events-none">
        {extendedLogos.map((logo, index) => (
          <div
            key={`${logo.alt}-${index}`}
            className="mx-8 shrink-0"
            style={{ flex: "0 0 auto" }}
          >
            <Image
              width={158}
              height={48}
              src={logo.src}
              alt={logo.alt}
              className="h-5 w-auto object-contain"
              loading="eager"
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
